import { Typography } from "@mui/material";
import { convertToDateTime } from "../../utils/datetime";

const DateRender = (date: string | null | undefined, showInline: boolean = false, isShowTime: boolean = true) => {
  if (!date || date === "0" || new Date(date).getTime() === 0) {
    return showInline ? "-" : <Typography>-</Typography>;
  }

  const dateTimeString = convertToDateTime(date);
  const [datePart, timePart] = dateTimeString.split(" ");

  if (showInline) {
    return dateTimeString;
  }

  return (
    <>
      <Typography>{datePart}</Typography>
      {isShowTime && <Typography>{timePart}</Typography>}
    </>
  );
}
export default DateRender;
